import { CloudArrowUp, CloudCheck, CloudSlash } from '../design-system/icons';
import { useDraftStatus, type DraftStatus } from './draftStatus';

const LABEL: Record<DraftStatus, string> = {
  idle: 'Drafts save automatically',
  saving: 'Saving…',
  saved: 'Draft saved',
  error: "Couldn't save draft",
};

export function DraftStatusBadge() {
  const status = useDraftStatus();
  const failed = status === 'error';
  return (
    <span className="flex h-8 items-center gap-1.5 rounded-lg border border-border bg-card px-2 text-body-sm-medium text-foreground sm:px-3.5">
      {failed ? (
        <CloudSlash size={15} className="text-destructive" aria-hidden="true" />
      ) : status === 'saving' ? (
        <CloudArrowUp size={15} className="text-muted-foreground" aria-hidden="true" />
      ) : (
        <CloudCheck size={15} className="text-muted-foreground" aria-hidden="true" />
      )}{' '}
      {/* Below sm the label drops to icon-only (still read by screen readers) so the right
          side doesn't push the breadcrumb out at 390px. */}
      <span className="max-sm:sr-only" aria-hidden={failed || undefined}>
        {LABEL[status]}
      </span>
      {/* Only a failure is announced: "Saving…" and "Draft saved" would fire at
          every typing pause. Always mounted so the text change is reliably read. */}
      <span role="alert" className="sr-only">
        {failed ? LABEL.error : ''}
      </span>
    </span>
  );
}
